import { SalaryAdvanceValueObjectsEmployeeStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const getEmployeeStatusLabel = (
  status: SalaryAdvanceValueObjectsEmployeeStatusEnum
): string => {
  switch (status) {
    case 'active':
      return i18n.t('salary_advance.employee.status.active')
    case 'pending_information':
      return i18n.t('salary_advance.employee.status.pending_information')
    case 'disabled':
      return i18n.t('salary_advance.employee.status.disabled')
    default:
      const exhaustiveCheck: never = status
      throw new Error(`Unhandled status: ${exhaustiveCheck}`)
  }
}

export const getEmployeeStatusVariant = (
  status: SalaryAdvanceValueObjectsEmployeeStatusEnum
): 'positive' | 'warning' | 'info' | 'critical' | 'neutral' => {
  switch (status) {
    case 'active':
      return 'positive'
    case 'pending_information':
      return 'warning'
    case 'disabled':
      return 'critical'
    default:
      const exhaustiveCheck: never = status
      throw new Error(`Unhandled status: ${exhaustiveCheck}`)
  }
}
